module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Advanced CSS</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-l\">\r\n        <input type=\"checkbox\" name=\"advancedCSSEnabled\" id=\"advancedCSSEnabled\" ")
    ; __append(escapeFn( u.isTrue(advancedCSSEnabled) ? "checked" : "" ))
    ; __append("  class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\" style=\"padding: 3px 3px 0;\">Enable Advanced CSS</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <div style=\"display: inline-flex;\">\r\n            <div class=\"nopadding button-opener\">\r\n                <button id=\"customCodeManager\" ")
    ; __append(escapeFn( u.isTrue(advancedCSSEnabled) ? "" : "disabled" ))
    ; __append(" class=\"btn btn-default hvr-glow\" style=\"width:100%; padding: 8px;\">Open\r\n                    CSS Manager</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}